// extracted by mini-css-extract-plugin
export default {"component":"nj0eRj","baseComponent":"bg5GoG","large":"RwM0Je","wide":"GBG3j3"};